import { createFileRoute, redirect } from '@tanstack/react-router';
import { authBaseUrl, isAlreadyOnAccountSecurity } from '~/features/auth/context/Session';
import { getBaseUrl } from '~/utils/getBaseUrl';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context, location }) => {
    if (
      context.isSsoSetupRequired &&
      !isAlreadyOnAccountSecurity({ pathname: location.pathname, search: location.searchStr })
    ) {
      // Intent preload runs beforeLoad and swallows this redirect, so the toast lives on the destination.
      throw redirect({
        to: '/account',
        search: {
          content: 'security',
          org: context.organisation?.slug,
          ssoRequired: true,
        },
      });
    }
  },
  loader: async ({ context }) => {
    const session = context.session;

    if (!session) {
      window.location.href = `${getBaseUrl(authBaseUrl)}/signin?return_to=${window.location.href}`;
    }
  },
});
